import { Directive, Input, ElementRef, OnInit } from '@angular/core';
import { RxEmitter } from '../rxjs/rx-emitter';

@Directive({
  selector: '[setFocusOn]'
})
export class SetFocusOnDirective implements OnInit {
  @Input() setFocusOn: string;

  constructor(private rxEmitter: RxEmitter,
              private element: ElementRef) {
  }

  ngOnInit() {
    this.rxEmitter.subscribe(this.setFocusOn, () => {
      this.element.nativeElement.focus();
    });
  }

}
